/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

/**
 * named imports for React.lazy: https://github.com/facebook/react/issues/14603#issuecomment-726551598
 *
 * Usage:
 * ```
 * const { Home } = lazyImport(() => import("./Home"), "Home");
 * ```
 */
export function lazyImport<T extends React.ComponentType<any>, I extends { [K2 in K]: T }, K extends keyof I>(
  factory: () => Promise<I>,
  name: K,
): I {
  return Object.create({
    [name]: React.lazy(() =>
      factory()
        .then((module) => ({ default: module[name] }))
        .catch((error) => {
          // If a module is not available because the name has changed after deployment,
          // reload the entire page when attempting to fetch it.
          window.location.reload();

          return Promise.reject(error);
        }),
    ),
  });
}
